<template>
  <div>
    <aside id="menu">
      <div id="navigation">
        <div>

          <div class="profile-picture">
            <router-link :to="$user.isFreeTrial() ? {name: 'Register'} : {name: 'Profile'}">
              <img alt="logo" class="img-circle"
                   :src="imgProfile"
                   style="height: 100px;width: 100px" >
            </router-link>

          </div>
          <div class="text-color text-center">
            <router-link :to="$user.isFreeTrial()?{name: 'Register'} :{name: 'Profile'}" class="font-extra-bold font-uppercase">
              <i class="fa fa-cog"></i> <span  style="margin-top: 5px">{{$auth.user().firstName}} {{$auth.user().lastName}}</span>
            </router-link>
            <div class="" style="margin-top: 5px">{{$auth.user().email}}
              <i v-if="$user.hasEmailVerified()" data-toggle="popover" data-content="verified" class="fa fa-check-circle text-success" data-original-title="" title=""></i>
              <i v-else data-toggle="popover" data-content="Email address not confirmed! <br> To validate your account, please follow the instructions in the email that was sent to you." class="fas fa-exclamation-circle text-warning" data-original-title="" title=""></i>
            </div>
            <div style="font-style: italic">({{$auth.user().role_name}} account)</div>
            <div class="font-bold" style="color: #000;">{{level.current}} Level</div>

          </div>
        </div>

        <ul class="nav" id="side-menu">
          <template v-if="$auth.user().profile.id === 2">
            <li v-bind:class="{active : $route.name === 'CropHome'}">
              <router-link :to="{name: 'CropHome'}"><i class="fa fa-home"></i> Home</router-link>
            </li>
            <li v-bind:class="{active : $route.name === 'Dashboard'}">
              <router-link :to="{name: 'Dashboard'}"><i class="fas fa-tachometer-alt"></i> My Dashboard</router-link>
            </li>
          </template>
          <template v-else-if="$user.isSe()">
            <li v-bind:class="{active : $route.name === 'SearchSimple'}" v-if="$user.isBasic()" id="nav-lea-simple-search">
              <router-link :to="{name: 'SearchSimple'}"><i class="fa fa-home"></i> LEA Simple Search</router-link>
            </li>
            <li v-bind:class="{active : $route.name === 'Dashboard'}">
              <router-link :to="{name: 'Dashboard'}"><i class="fas fa-tachometer-alt"></i> My Dashboard</router-link>
            </li>
          </template>
          <template v-else>
            <li v-if="$user.isBasic()" v-bind:class="{active : $route.name === 'Start'}" id="nav-start">
              <router-link :to="{name: 'Start'}"><i class="fa fa-play"></i> Let's start</router-link>
            </li>
            <li v-bind:class="{active : $route.name === 'Dashboard'}">
              <router-link :to="{name: 'Dashboard'}"><i class="fa fa-home"></i> My Dashboard</router-link>
            </li>
          </template>
          <li v-if="$user.isBasic() && !$user.isSe()" v-bind:class="{active : $route.name === 'SearchSimple'}">
            <router-link :to="{name:'SearchSimple'}"><i class="fa fa-search"></i> Simple Search</router-link>
          </li>
          <li v-bind:class="{active : $route.name === 'Projects'}">
            <router-link :to="{name: 'Projects'}"><i class="fa fa-rocket"></i> My Projects</router-link>
          </li>
          <li v-bind:class="{active : $route.name === 'Documents'}" v-if="($user.isCorporate() || $user.isIdexlab()) && !$user.isBasic()">
            <router-link :to="{name: 'Documents'}" title="See internal Reports or  Generate/Verify PoE"><i class="fas fa-download"></i> My Documents</router-link>
          </li>
          <li v-if="hasReceiveQuestion" v-bind:class="{active : $route.name === 'ReceiveQuestions'}">
            <router-link :to="{name: 'ReceiveQuestions'}"><i class="fa fa-question-circle"></i> Received Questions</router-link>
          </li>
          <template v-if="$auth.check('broker') || $auth.check('manager') || $auth.check('super_admin')">

            <li v-bind:class="{active : $route.name === 'ManageUsers'}">
              <router-link :to="{name: 'ManageUsers'}"><i class="fa fa-users"></i> Manage Team</router-link>
            </li>

            <template v-if="this.$auth.check('super_admin')">
              <li v-bind:class="{active : $route.name === 'ManageProfiles'}">
                <router-link :to="{name: 'ManageProfiles'}"><i class="fa fa-users"></i> Manage Profiles</router-link>
              </li>
            </template>

            <template v-if="this.$auth.check('super_admin')">
              <li v-bind:class="{active : $route.name === 'EditData'}">
                <router-link :to="{name: 'EditData'}"><i class="fa fa-users"></i> Edit data</router-link>
              </li>
            </template>
            <li v-bind:class="{active : $route.name === 'Stats'}">
              <router-link v-if="$auth.check('super_admin') || $auth.check('manager') || ( $auth.check('broker') && $user.isCorporate()) " :to="{name: 'Stats'}"><i class="fa fa-chart-pie"></i> Team Stats</router-link>
              <a v-else @click="$refs.limitPlan.show('team_stats')"><i class="fa fa-chart-pie"></i> Team Stats</a>
            </li>
          </template>
          <li v-if="!$user.isSe()">
            <a :href="public_question_url" target="_blank"><i class="fa fa-trophy"></i> Public Questions</a>
          </li>
          <template v-if="$user.isSe()">
            <li v-bind:class="{active : $route.name === 'LeaPlans'}">
              <router-link :to="{name: 'LeaPlans'}"><i class="fa fa-cog"></i> Subscription plans</router-link>
            </li>
          </template>
          <template v-else>
            <li v-bind:class="{active : $route.name === 'Plans'}">
              <router-link :to="{name: 'Plans'}"><i class="fa fa-cog"></i> Subscription plans</router-link>
            </li>
          </template>
        </ul>

        <div v-if="displayUpdateProfilePlanRole() === true" style="padding-left: 25px">
          <h4>Profiles</h4>
          <v-select2 :options="profiles" label="name" :placeholder="'profile'" v-model="profileSelected"></v-select2>
          <template v-if="profileSelected !== null">
            <h4>Plans</h4>
            <v-select2 :options="plans" label="name" :placeholder="'plan'" v-model="planSelected"></v-select2>
          </template>
          <template v-if="roleSelected !== null">
            <h4>Roles</h4>
            <v-select2 :options="roles" label="name" :placeholder="'role'" v-model="roleSelected"></v-select2>
            <div class="text-center m-t-md m-b-lg">
              <button class="btn btn-danger" @click="updateProfilePlanRole()">Submit</button>
            </div>
          </template>
        </div>
      </div>
    </aside>
    <limit-plan ref="limitPlan"></limit-plan>
  </div>
</template>

<script>
import LimitPlan from '../../components/LimitPlan'
import VSelect2 from '../utils/select2'

export default {
  name: 'Navigation',
  components: {VSelect2, LimitPlan},
  data () {
    return {
      firstName: null,
      lastName: null,
      hasReceiveQuestion: false,
      public_question_url: null,
      imgProfile: '/uploads/user/avatar.png',
      profiles: [],
      profileSelected: null,
      plans: [],
      planSelected: null,
      roles: [],
      roleSelected: null,
      level: null
    }
  },
  methods: {
    getProfileImageUrl: function () {
      let userPicture = this.$auth.user().picture
      let imgProfile

      if (userPicture === null) {
        imgProfile = this.$apiUrl + '/uploads/user/avatar.png'
      } else if (userPicture.indexOf('http') === 0) {
        imgProfile = userPicture
      } else {
        imgProfile = this.$apiUrl + '/uploads/user/profile/' + userPicture
      }

      return imgProfile
    },
    updateProfilePlanRole: function () {
      let data = {
        profile_id: this.profileSelected.id,
        role_id: this.roleSelected.id,
        plan_id: this.planSelected.id
      }

      this.axios.patch('development/updateProfilePlanRole', data).then((response) => {
        this.$auth.fetch()

        this.$notify({
          type: 'success',
          title: 'Profile, role, plan updated',
          content: 'need refresh for logo',
          placement: 'bottom-right'
        })
      })
    },
    displayUpdateProfilePlanRole: function () {
      if (process.env.NODE_ENV !== 'production') {
        if (this.$auth.user().email.indexOf('@idexlab.com') !== -1) {
          return true
        }
      }
      return false
    }
  },
  watch: {
    profileSelected: function (val, oldVal) {
      if (val !== null) {
        this.planSelected = this.$auth.user().plan.plan
        this.axios.get('profile/' + val.id + '/plansAvailable').then((response) => {
          this.plans = response.data
        })

        if (oldVal !== null) {
          this.planSelected = null
          this.roleSelected = null
        }
      }
    },
    planSelected: function (val) {
      if (val !== null) {
        let currentNameRole = this.$auth.user().roles[0]
        this.axios.get('plan/' + val.id + '/rolesAvailable').then((response) => {
          this.roles = response.data

          this.roles.push({id: 1, name: 'super_admin'})
          this.roleSelected = this.roles.find((role) => {
            return currentNameRole === role.name
          })
        })
      } else {
        this.roleSelected = null
      }
    }
  },
  mounted () {
    $('#side-menu').metisMenu()
    $('[data-toggle="popover"]').popover({
      trigger: 'hover',
      placement: 'top',
      container: 'body',
      html: true
    })
    this.firstName = this.$auth.user().firstName
    this.lastName = this.$auth.user().lastName
    this.imgProfile = this.getProfileImageUrl()
    this.hasReceiveQuestion = this.$auth.user().receiveQuestion
    this.public_question_url = this.$auth.user().profile.id === 2
      ? process.env.WEBSITE_URL + '/crop-public-questions' : process.env.WEBSITE_URL + '/public-questions'
  },
  beforeMount () {
    if (process.env.NODE_ENV !== 'production') {
      this.profileSelected = this.$auth.user().profile
      this.axios.get('/profiles').then((response) => {
        this.profiles = response.data
      })
    }
    this.level = this.$user.level()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/Navigation.vue